export default __webpack_public_path__ + "static/media/logo-horizont.7d47daaa.svg";